import { Component, Input } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { CModalFileViewComponent } from '../c-modal-file-view/c-modal-file-view.component';
import { App_formDoc, DocEditable, DocumentElaborationForm } from 'src/app/utils/interfaces';
import { FileService } from 'src/app/services/app/file.service';
import { Directory } from '@capacitor/filesystem';
import { AbstractControl, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { blobTo64 } from 'src/app/utils/utils';
import { DocumentsLevagesEditablesEnCoursPipe, DocumentsLevagesEditablesPipe, GetDocumentLevageEditableTitlePipe } from 'src/app/pipes/documents-levages-editables/documents-levages-editables.pipe';
import { Md5 } from 'md5-typescript';
import { firstValueFrom } from 'rxjs';
import { SafeLiftService } from 'src/app/services/app/safelift.service';

@Component({
  selector: 'app-c-modal-display-documents',
  templateUrl: './c-modal-display-documents.component.html',
  styleUrls: ['./c-modal-display-documents.component.scss'],
})
export class CModalDisplayDocumentsComponent {
  @Input() documentsModele: App_formDoc[] = [];
  @Input() documentsLevage: App_formDoc[] = [];
  @Input() documentsLevageHandlingForm: FormArray<FormControl<DocumentElaborationForm>> | undefined = undefined;

  addDocForm = this.formBuilder.control('', [Validators.required, Validators.pattern('^[^\.\,]+$'), ctrl => this.pasDeNomDoublon(ctrl)])

  constructor(
    private alertController: AlertController,
    private modalController: ModalController,
    private fileService: FileService,
    private formBuilder: FormBuilder,
    private safeLiftService: SafeLiftService
  ) { }

  closeModal() {
    this.modalController.dismiss();
  }

  async onDocumentModeleOpenClick(document: App_formDoc) {
    this.fetchDocumentDatas(document)
    .then(dataBase64 => {
      this.openDocument(dataBase64)
    }).catch(err => this.alertController.create({
      message: `Le document n'a pas été trouvé sur l'appareil et n'a pas pu être récupéré sur le serveur. `,
      buttons: [`OK`]
    }).then(alrt => alrt.present()))
  }
  onDocumentLevageOpenClick(document: App_formDoc) {
    this.fetchDocumentDatas(document)
    .then(dataBase64 => {
      this.openDocument(dataBase64)
    }).catch(err => this.alertController.create({
      message: `Le document n'a pas été trouvé sur l'appareil et n'a pas pu être récupéré sur le serveur. `,
      buttons: [`OK`]
    }).then(alrt => alrt.present()))
  }

  onEditableDocumentLevageDeleteClick(document: DocEditable) {
    if (this.documentsLevageHandlingForm) {
      const docInForm = document.docInForm;
      if (document.doc) {
        if (docInForm) {
          const value = docInForm.value;
          docInForm.setValue({
            delete: 1,
            filename: document.doc.title,
            value: value.value,
          })
        } else {
          const val: DocumentElaborationForm = {
            delete: 1,
            filename: document.doc.title,
            value: '',
          }
          const newDocInForm = this.formBuilder.control(val) as FormControl<DocumentElaborationForm>;
          this.documentsLevageHandlingForm.push(newDocInForm);
        }
      } else {
        if (docInForm) {
          const value = this.documentsLevageHandlingForm.value;
          if (Array.isArray(value)) {
            const index = value.findIndex(e => typeof e.filename === 'string' && e.filename === docInForm.value.filename);
            if (index !== -1) {
              this.documentsLevageHandlingForm.removeAt(index);
            }
          }
        }
      }
    }
  }

  onEditableDocumentLevageCancelDeleteClick(document: DocEditable) {
    if (this.documentsLevageHandlingForm) {
      const docInForm = document.docInForm;
      if (document.doc) {
        if (docInForm) {
          const value = this.documentsLevageHandlingForm.value;
          if (Array.isArray(value)) {
            const index = value.findIndex(e => typeof e.filename === 'string' && e.filename === docInForm.value.filename);
            if (index !== -1) {
              this.documentsLevageHandlingForm.removeAt(index);
            }
          }
        }
      }
    }
  }

  onEditableDocumentLevageOpenClick(document: DocEditable) {
    const rawValueIfEdited = document?.docInForm?.value?.value;
    if (typeof rawValueIfEdited === 'string' && rawValueIfEdited.length > 0) {
      this.openDocument(rawValueIfEdited)
    } else if (document.doc) {
      this.fetchDocumentDatas(document.doc)
      .then(dataBase64 => {
        this.openDocument(dataBase64)
      })
      .catch(err => this.alertController.create({
          message: `Le document n'a pas été trouvé sur l'appareil et n'a pas pu être récupéré sur le serveur. `,
          buttons: [`OK`]
        }).then(alrt => alrt.present()))
    }
  }

  fetchDocumentDatas(document: App_formDoc): Promise<string> {
    return this.fileService.readFile(`documents/${Md5.init(document.web)}`, Directory.Data)
    .catch(err => {
      return firstValueFrom(this.safeLiftService.fetchDocument(document)).then(res => this.fileService.readFile(`documents/${Md5.init(document.web)}`, Directory.Data))
    })
    .then(readfileResult => readfileResult.data as string)
    .then(srcReplace => {
      const type = document.mime_type;
      return `data:${type};base64,${srcReplace}`
    })
  }

  openDocument(dataBase64: string) {
    this.modalController.create({
      component: CModalFileViewComponent,
      componentProps: {
        source: dataBase64,
        type: 'pdf'
      },
      cssClass: 'modal-file-view modal-pdf-view',
    }).then(_ => _.present())
  }

  onAddNewDocLevageClick(fileInput: any) {
    fileInput.click();
  }

  async uploadDocument($event: any) {
    if (this.documentsLevageHandlingForm && this.addDocForm.valid) {
      const srcElement = $event.srcElement
      const x: FileList = srcElement.files;
      const docFieldValue = x.item(0);
      if (docFieldValue instanceof Blob) {
        if (docFieldValue.type === 'application/pdf') {
          const value = await blobTo64(docFieldValue);
          const x: DocumentElaborationForm = {
            filename: `${this.addDocForm.value}.pdf`,
            value
          }
          const formControlToAdd = this.formBuilder.control(x) as FormControl<DocumentElaborationForm>
          this.documentsLevageHandlingForm.push(formControlToAdd)
        } else {
          this.alertController.create({
            message: `Le document doit être un pdf`,
            buttons: [`OK`]
          }).then(alrt => alrt.present())
        }
        this.deleteFieldsValue(srcElement);
      }
    }
  }

  deleteFieldsValue(srcElement: any) {
    srcElement.value = null;
    this.addDocForm.reset('');
  }

  pasDeNomDoublon(ctrl: AbstractControl) {
    const documentsLevagesEditablesP = new DocumentsLevagesEditablesPipe();
    const documentsLevagesEditablesEnCoursP = new DocumentsLevagesEditablesEnCoursPipe();
    const getDocumentLevageEditableTitlePipe = new GetDocumentLevageEditableTitlePipe();
    const listeExistant = documentsLevagesEditablesEnCoursP.transform(documentsLevagesEditablesP.transform(this.documentsLevage, this.documentsLevageHandlingForm, this.documentsLevageHandlingForm?.value))

    if (Array.isArray(listeExistant)) {
      const listeNoms = listeExistant
      .map(document => getDocumentLevageEditableTitlePipe.transform(document))
      .filter(str => typeof str === 'string')
      .map(str => str.replace(/\.[A-Za-z]+$/, ''));
    return !listeNoms.includes(ctrl.value)
      ? null
      : {
        err: `Doublon`
      };
    }
    return null;
  }

}
